<template lang="pug">
    div
        // p(style="text-align: center; font-weight: bold;") {{ chartTitle }}
        components(
            :is="chartMap[chartVisualizeType].component"
            v-bind="chartMap[chartVisualizeType].props"
            @onLegendClick="onLegendClick"
            ref="chartWrappers"
            style="height: 100%"
            )
</template>
<script>
import colorScheme from "@/data/colorScheme";

import LineChartWrapper from "@/components/dashboard/LineChartWrapperV2";
// import BarChartWrapper from "@/components/dashboard/BarChartWrapperV2";
import SingleNumWrapper from "@/components/dashboard/SingleNumWrapperV2";
import PieChartWrapper from "@/components/dashboard/PieChartWrapperV2";

import BarChartHorizontalWrapper from "@/components/dashboard/BarChartHorizontalWrapperV2";
import BarChartVerticalWrapper from "@/components/dashboard/BarChartVerticalWrapperV2";

import bus from "@/libs/bus.js";

import { getEdgeChartDataV2 } from "@/api/monitor.js";

export default {
    props: {
        category: { type: String, default: "existedChart" },
        chartTitle: { type: String, default: "" },
        chartMetric: { type: String, default: "count" },
        chartMetricGroupBy: { type: String, default: "none" },
        chartMetricGroupByTerms: { type: String, default: "" },
        chartMetricGroupByTermSize: { type: Number, default: 3 },
        chartVisualizeType: { type: String, default: "lineChart" },
        chartMetricGroupByFilters: { type: Array, default: () => [] },
        dashboardQueryFilters: { type: Array, default: () => [] },
        chartQueryFilters: { type: Array, default: () => [] },

        // 用來標示物件, 相當於key
        chartIndex: { type: String, default: "" },
    },
    components: {
        LineChartWrapper,
        // BarChartWrapper,
        SingleNumWrapper,
        PieChartWrapper,
        BarChartHorizontalWrapper,
        BarChartVerticalWrapper,
    },
    data() {
        return {
            colorScheme,
        };
    },
    computed: {
        chartMap() {
            return {
                lineChart: {
                    component: "LineChartWrapper",
                    props: {
                        chartTitle: this.chartTitle,
                        titleDisplay: false,
                        withCard: false,
                        chartHeight: 200,
                        numeralFormat: this.numeralFormat,
                        linePointRadius: [4],
                        linePointHoverRadius: [8],
                        linePointBackgroundColor: ["white"],
                        linePointBorderWidth: [3],
                        lineBorderColors: colorScheme.colorSets.border,
                        // linePointHoverBorderWidth: [5],
                        // linePointHoverBorderColor: ["rgba(152, 202, 235, 0.5)"],
                        // linePointHoverBackgroundColor: ["white"],
                        // lineBackgroundGradientStops: [colorScheme.blue.gradientStops],
                        useBackendDatasetLabel: true,
                        legendPosition: "right",
                    },
                },
                // barChart: {
                //     component: "BarChartWrapper",
                //     props: {
                //         chartTitle: this.chartTitle,
                //         titleDisplay: false,
                //         topNSize: 3,
                //         chartHeight: 200,
                //         withCard: false,
                //         numeralFormat: this.numeralFormat,
                //         direction: "horizontal",
                //         // direction: "vertical",
                //         // barBorderColors: [colorScheme.blue.border],
                //         // barBackgroundColors: [colorScheme.blue.fill],
                //         barBackgroundColors: colorScheme.colorSets.fill,
                //         legendPosition: "right",
                //         useBackendDatasetLabel: true
                //     }
                // },
                barChartHorizontal: {
                    component: "BarChartHorizontalWrapper",
                    props: {
                        chartTitle: this.chartTitle,
                        titleDisplay: false,
                        topNSize: 3,
                        chartHeight: 200,
                        chartWidth: this.category == "newChart" ? 1100 : 600,
                        withCard: false,
                        numeralFormat: this.numeralFormat,
                        direction: "horizontal",
                        // direction: "vertical",
                        // barBorderColors: [colorScheme.blue.border],
                        // barBackgroundColors: [colorScheme.blue.fill],
                        barBackgroundColors: colorScheme.colorSets.fill,
                        legendPosition: "right",
                        useBackendDatasetLabel: true,
                    },
                },
                barChartVertical: {
                    component: "BarChartVerticalWrapper",
                    props: {
                        chartTitle: this.chartTitle,
                        titleDisplay: false,
                        topNSize: 3,
                        chartHeight: 200,
                        chartWidth: this.category == "newChart" ? 1100 : 600,
                        withCard: false,
                        numeralFormat: this.numeralFormat,
                        direction: "vertical",
                        // direction: "vertical",
                        // barBorderColors: [colorScheme.blue.border],
                        // barBackgroundColors: [colorScheme.blue.fill],
                        barBackgroundColors: colorScheme.colorSets.fill,
                        legendPosition: "right",
                        useBackendDatasetLabel: true,
                    },
                },
                pieChart: {
                    component: "PieChartWrapper",
                    props: {
                        chartTitle: this.chartTitle,
                        titleDisplay: false,
                        topNSize: 3,
                        chartHeight: 200,
                        withCard: false,
                        numeralFormat: this.numeralFormat,
                        pieBackgroundColors: [colorScheme.colorSets.fill],
                        legendPosition: "right",
                        legendAlign: "start",
                    },
                },
                singleNumberChart: {
                    component: "SingleNumWrapper",
                    props: {
                        chartTitle: this.chartTitle,
                        titleDisplay: false,
                        numeralFormat: this.numeralFormat,
                        withCard: false,
                        textInSingleLine: false,
                        maxFontSize: "16px",
                        style: "text-align: right;",
                    },
                },
            };
        },
        numeralFormat() {
            let metricFormat = {
                count: "0a",
                dataUsage: "0b",
                unique: "0a",
                requestProcessTime: "0.00a",
                upstreamProcessTime: "0.00a",
            };
            return metricFormat[this.chartMetric];
        },
    },
    mounted() {
        console.log("CDNChart Mounted");
        this.getDataAndDraw();

        bus.$on("reloadChart", () => {
            console.log("CHART RELOAD");
            this.getDataAndDraw();
        });
    },
    beforeDestroy() {
        bus.$off("reloadChart");
    },
    methods: {
        onLegendClick(name) {
            console.log(`${this.chartVisualizeType} get click label: ${name}`);
            this.$emit("onLegendClick", {
                name,
                chartIndex: this.chartIndex,
            });
        },
        getDataAndDraw() {
            this.$nextTick(() => {
                getEdgeChartDataV2({
                    chartVisualizeType: this.chartVisualizeType,
                    chartMetric: this.chartMetric,
                    chartMetricGroupBy: this.chartMetricGroupBy,
                    chartMetricGroupByTerms: this.chartMetricGroupByTerms,
                    chartMetricGroupByTermSize: this.chartMetricGroupByTermSize,
                    chartMetricGroupByFilters: this.chartMetricGroupByFilters,
                    chartQueryFilters: this.chartQueryFilters,
                    dashboardQueryFilters: this.dashboardQueryFilters,
                    groupNames: this.$store.state.queryGroupName,
                    dateRangeOptions: {
                        index: this.$store.state.dashboard.queryFilter.dateRangeOptions.index,
                        customTimeRange: this.$store.state.dashboard.queryFilter.dateRangeOptions.customTimeRange,
                    },
                }).then((result) => {
                    this.$refs.chartWrappers.fillChartData(result);
                });
            });
        },
    },
    watch: {
        "$store.state.userPref.lang": function (newVal, oldVal) {
            // this.fillChartData(this.givenChartData);
            this.getDataAndDraw();
            // this.fillChartData(this.nginxData);
        },
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/dashboard/CDNChart.vue